import { useEffect, useState } from "react";

import { getS3DownloadUrl } from "@/api/s3/s3.mutations";

export function useS3ImageUrl(s3Key: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!s3Key) {
      setUrl(null);
      return;
    }

    let cancelled = false;

    getS3DownloadUrl({ key: s3Key })
      .then((response) => {
        if (!cancelled) setUrl(response.data.url);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });

    return () => {
      cancelled = true;
    };
  }, [s3Key]);

  return url;
}
